import { useState } from "react";
import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { useCart } from "@/context/CartContext";
import { cadShort } from "@/lib/site";

const ShopItem = ({ t, active, onHover }) => {
  const p = t.product;
  const { addItem } = useCart();
  const oneSize = "OS" in p.sizes;
  const [size, setSize] = useState(oneSize ? "OS" : "");
  const [color, setColor] = useState(p.colors[0].name);
  const [busy, setBusy] = useState(false);
  const add = async () => { setBusy(true); await addItem(p, { color, size, qty: 1, image: p.image }); setBusy(false); };
  return (
    <li onMouseEnter={onHover} className={`flex gap-4 rounded-[16px] border p-3 transition-colors ${active ? "border-ink bg-lime/40" : "border-ink/15"}`} data-testid={`look-item-${p.slug}`}>
      <Link to={`/product/${p.slug}`} className="tile h-20 w-20 shrink-0"><img src={p.image} alt={p.name} className="h-full w-full object-cover mix-blend-multiply" /></Link>
      <div className="min-w-0 flex-1">
        <Link to={`/product/${p.slug}`} className="font-a text-[15px] hover:underline" data-testid={`look-item-link-${p.slug}`}>{p.name}</Link>
        <p className="text-[13px] text-ink/60">{cadShort(p.price)}</p>
        <div className="mt-2 flex flex-wrap items-center gap-2">
          {p.colors.length > 1 && <select value={color} onChange={(e) => setColor(e.target.value)} className="rounded-[8px] border border-ink/30 bg-cloud px-2 py-1 text-xs" data-testid={`look-color-${p.slug}`}>{p.colors.map((c) => <option key={c.name}>{c.name}</option>)}</select>}
          {!oneSize && <select value={size} onChange={(e) => setSize(e.target.value)} className="rounded-[8px] border border-ink/30 bg-cloud px-2 py-1 font-mono text-xs" data-testid={`look-size-${p.slug}`}><option value="">Size</option>{Object.entries(p.sizes).map(([s, n]) => <option key={s} value={s} disabled={!n}>{s}{!n ? " (sold out)" : ""}</option>)}</select>}
          <button onClick={add} disabled={!size || busy || p.drop_slug === "sus-world"} className="btn btn-ink !h-8 !px-3 !text-[10px]" data-testid={`look-add-${p.slug}`}>{busy ? "…" : "Add"}</button>
        </div>
      </div>
    </li>
  );
};

export const LookLightbox = ({ look, onClose }) => {
  const [active, setActive] = useState(null);
  return (
    <Dialog open={!!look} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[94vh] max-w-5xl overflow-y-auto rounded-[24px] border-[1.5px] border-ink bg-cloud p-0" data-testid="look-lightbox">
        {look && (
          <div className="grid md:grid-cols-[1.1fr_1fr]">
            <div className="relative m-3 self-start overflow-hidden rounded-[18px]" data-testid="look-lightbox-image">
              <img src={look.src} alt={look.alt} className="photo block h-full max-h-[80vh] w-full object-cover" />
              {look.tags.map((t, i) => (
                <button key={t.product_slug + i} onMouseEnter={() => setActive(t.product_slug)} onClick={() => setActive(t.product_slug)} style={{ left: `${t.x}%`, top: `${t.y}%` }} aria-label={`Show ${t.product.name}`}
                  className={`absolute flex h-7 w-7 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border-2 border-ink shadow-[0_0_0_4px_rgba(244,243,236,.7)] transition-transform hover:scale-110 ${active === t.product_slug ? "bg-pink" : "bg-lime"}`} data-testid={`look-hotspot-${i}`}>
                  <span className="h-2 w-2 rounded-full bg-ink" />
                </button>
              ))}
            </div>
            <div className="p-6 sm:p-8">
              <DialogTitle className="display text-5xl">Shop the look</DialogTitle>
              <DialogDescription className="label mt-2 text-ink/60">{look.caption} · {look.tags.length} pieces</DialogDescription>
              <ul className="mt-6 space-y-3">{look.tags.map((t) => <ShopItem key={t.product_slug} t={t} active={active === t.product_slug} onHover={() => setActive(t.product_slug)} />)}</ul>
              {!look.tags.length && <p className="mt-6 text-ink/60">No tagged pieces yet.</p>}
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
